import { AudioObject, BroadcastEvent, DayOfWeek, RadioBroadcastService, WithContext } from 'schema-dts'

import { contextUrl } from '@/common/json-ld/util'
import { localBusiness } from '@/common/json-ld/organization'
import { Schedule } from '@/common/models/data/dashboard/schedule/schedule'
import { VoiceBankEntry } from '@/common/models/data/dashboard/voice-bank/voice-bank-entry'

const broadcastEvent = (event: Schedule): WithContext<BroadcastEvent> => {
    const daysOfWeek: Array<DayOfWeek> = [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday'
    ]

    const duration = event.end.diff(event.start, ['hours', 'minutes']).toISO()

    const data: WithContext<BroadcastEvent> = {
        '@context': contextUrl,
        '@type': 'BroadcastEvent',
        'name': event.title,
        'duration': duration,
        'eventSchedule': {
            '@type': 'Schedule',
            'repeatFrequency': 'P1W',
            'byDay': daysOfWeek[event.day - 1],
            'duration': duration,
            'startDate': event.start_hour,
            'endDate': event.end_hour
        },
        'isLiveBroadcast': true
    }

    if (event.description) data.description = event.description
    if (event.player_image) {
        data.image = event.player_image
    } else if (event.schedule_image) {
        data.image = event.schedule_image
    }

    return data
}

const radioBroadcastService = (source: string): WithContext<RadioBroadcastService> => {
    return {
        '@context': contextUrl,
        '@type': 'RadioBroadcastService',
        'name': 'Radio1.7',
        'broadcastDisplayName': 'Radio1.7',
        'broadcastTimezone': 'UTC+02:00',
        'broadcaster': localBusiness(),
        'hasBroadcastChannel': {
            '@type': 'BroadcastChannel',
            'broadcastServiceTier': 'Standard',
            'url': source
        }
    }
}

const voiceBankEntry = (entry: VoiceBankEntry): WithContext<AudioObject> => {
    return {
        '@context': contextUrl,
        '@type': 'AudioObject',
        'caption': entry.name,
        'contentUrl': entry.download_url,
        'url': entry.download_url,
        'encodingFormat': 'audio/mpeg',
        'productionCompany': localBusiness()
    }
}

export {
    broadcastEvent, radioBroadcastService, voiceBankEntry
}
